import React from 'react';
import * as XLSX from 'xlsx';

const FrameSealantWeightVerification = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const frameSealantData = inspectionData.FrameSealantWeightVerification;

  if (!frameSealantData) {
    return <p className="text-gray-500">No Frame Sealant Weight Verification data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Line',
      'Remarks',
      'Total Module Glue Weight',
      'Frame Weight With Glue - Long 1',
      'Frame Weight With Glue - Long 2',
      'Frame Weight With Glue - Short 1',
      'Frame Weight With Glue - Short 2',
      'Frame Weight Without Glue - Long 1',
      'Frame Weight Without Glue - Long 2',
      'Frame Weight Without Glue - Short 1',
      'Frame Weight Without Glue - Short 2',
      'Weight of Glue 1 Set - Glue Weight L1',
      'Weight of Glue 1 Set - Glue Weight L2',
      'Weight of Glue 1 Set - Glue Weight S1',
      'Weight of Glue 1 Set - Glue Weight S2',
    ]);

    // Populate data for each line
    Object.entries(frameSealantData).forEach(([lineKey, lineData]) => {
      worksheetData.push([
        lineKey,
        lineData.remarks,
        lineData.totalModuleGlueWeight,
        lineData.frameWeightWithGlue.frameWeightLong1,
        lineData.frameWeightWithGlue.frameWeightLong2,
        lineData.frameWeightWithGlue.frameWeightShort1,
        lineData.frameWeightWithGlue.frameWeightShort2,
        lineData.frameWeightWithoutGlue.frameWeightLong1,
        lineData.frameWeightWithoutGlue.frameWeightLong2,
        lineData.frameWeightWithoutGlue.frameWeightShort1,
        lineData.frameWeightWithoutGlue.frameWeightShort2,
        lineData.weightOfGlue1Set.glueWeightL1,
        lineData.weightOfGlue1Set.glueWeightL2,
        lineData.weightOfGlue1Set.glueWeightS1,
        lineData.weightOfGlue1Set.glueWeightS2,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FrameSealantWeight');
    XLSX.writeFile(workbook, 'FrameSealantWeightData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">Frame Sealant Weight Verification</h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(frameSealantData).map(([lineKey, lineData]) => (
        <div key={lineKey} className="border-b pb-4">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">{lineKey}</h3>

          {/* Scalar Fields */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Details</h4>
            <div className="grid grid-cols-2 gap-4">
              <p><strong>Remarks:</strong> {lineData.remarks || 'N/A'}</p>
              <p><strong>Total Module Glue Weight:</strong> {lineData.totalModuleGlueWeight || 'N/A'}</p>
            </div>
          </div>

          {/* Frame Weight With Glue */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Frame Weight With Glue</h4>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Frame Weight Long 1</th>
                    <th className="px-4 py-2 text-left text-gray-700">Frame Weight Long 2</th>
                    <th className="px-4 py-2 text-left text-gray-700">Frame Weight Short 1</th>
                    <th className="px-4 py-2 text-left text-gray-700">Frame Weight Short 2</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">{lineData.frameWeightWithGlue.frameWeightLong1 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.frameWeightWithGlue.frameWeightLong2 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.frameWeightWithGlue.frameWeightShort1 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.frameWeightWithGlue.frameWeightShort2 || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Frame Weight Without Glue */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Frame Weight Without Glue</h4>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Frame Weight Long 1</th>
                    <th className="px-4 py-2 text-left text-gray-700">Frame Weight Long 2</th>
                    <th className="px-4 py-2 text-left text-gray-700">Frame Weight Short 1</th>
                    <th className="px-4 py-2 text-left text-gray-700">Frame Weight Short 2</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">{lineData.frameWeightWithoutGlue.frameWeightLong1 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.frameWeightWithoutGlue.frameWeightLong2 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.frameWeightWithoutGlue.frameWeightShort1 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.frameWeightWithoutGlue.frameWeightShort2 || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Weight of Glue 1 Set */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Weight of Glue 1 Set</h4>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Glue Weight L1</th>
                    <th className="px-4 py-2 text-left text-gray-700">Glue Weight L2</th>
                    <th className="px-4 py-2 text-left text-gray-700">Glue Weight S1</th>
                    <th className="px-4 py-2 text-left text-gray-700">Glue Weight S2</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">{lineData.weightOfGlue1Set.glueWeightL1 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.weightOfGlue1Set.glueWeightL2 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.weightOfGlue1Set.glueWeightS1 || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.weightOfGlue1Set.glueWeightS2 || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FrameSealantWeightVerification;